export const TEST_ID_MOBILE_SUMMARY_PRICE_DETAIL =
  'mobile-summary-price-detail';
